module.exports = __webpack_public_path__ + "img/woshou2.3f7419d1.png";